import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function FounderPage() {
  return (
    <main data-testid="founder-page" className="bg-[#EFE8DC] text-[#2C241E] pt-24">
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <Reveal>
          <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
            The Founder
          </p>
          <h1
            data-testid="founder-page-headline"
            className="font-display text-4xl sm:text-5xl md:text-7xl tracking-tighter leading-[1.02] text-[#2C241E] max-w-4xl"
          >
            The Physio Who Hated His Own Gear.
          </h1>
        </Reveal>
        <div className="mt-16 max-w-3xl">
          <div className="space-y-6">
            <Reveal delay={0.15}>
              <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/75">
                LIGATEN started in a treatment room in Melbourne. Dr Shivam Jhatta PT —
                twenty-five, physiotherapist, and quietly obsessive about design — kept prescribing
                support wear he wouldn't be caught dead wearing himself.
              </p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/75">
                The people he treated agreed. The braces worked; they just looked like an apology.
                Beige velcro, hospital plastic, everything whispering injured. People wore them
                until they could walk, then hid them forever.
              </p>
            </Reveal>
            <Reveal delay={0.29}>
              <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/75">
                So he built the alternative: recovery wear designed like something you'd choose,
                not something you're assigned. Performance-grade support, a shade family borrowed
                from good coffee and better interiors, and words stitched where logos used to be.
              </p>
            </Reveal>
            <Reveal delay={0.36}>
              <p className="font-display italic text-2xl md:text-3xl text-[#2C241E] border-l-2 border-[#A07856] pl-6 py-2">
                "Support shouldn't look like a setback."
              </p>
            </Reveal>
            <Reveal delay={0.42}>
              <Link
                to="/join"
                data-testid="founder-page-join-link"
                className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-[#2C241E]/70 transition-colors duration-200 hover:text-[#2C241E]"
              >
                Join the list
                <ArrowRight size={16} strokeWidth={1.75} />
              </Link>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
